export const COMPANY = {
  name: "Nenyre Servizi",
  email: "info@nenyreservizi.it",
  legalName: "Nenyre Group srl",
  address: "Via A. Pisano 7B, 37131 Verona",
  phone: "045 2456660",
  vat: "05008770231",
};

export const SERVICES = [
  {
    slug: "privacy-condomini",
    nav: "Privacy per condomini",
    eyebrow: "GDPR · Regolamento UE 2016/679",
    title: "Privacy per condomini",
    image: "/condominio.jpg",
    intro: "Adeguamento completo del condominio alla normativa sulla protezione dei dati personali, con documenti sempre aggiornati e consultabili online dai condòmini.",
    points: [
      ["Informative pubblicate online", "Ogni condominio ha la sua pagina: i condòmini consultano e scaricano le informative inserendo il codice fiscale del condominio."],
      ["Accordo di contitolarità", "Disciplina dei ruoli tra condòmini contitolari e amministratore responsabile del trattamento, ai sensi degli artt. 26 e 28 GDPR."],
      ["Videosorveglianza", "Informativa estesa e indicazioni per l'impianto nelle parti comuni, nel rispetto dell'art. 1122-ter c.c. e delle linee guida EDPB 3/2019."],
      ["Antincendio e DUVRI", "Informativa antincendio per i residenti e documento di valutazione dei rischi da interferenze per le imprese che operano in condominio."],
      ["Aggiornamento continuo", "I documenti vengono aggiornati in base all'evoluzione della normativa e delle indicazioni del Garante."],
    ],
    cta: { label: "Cerca le informative del tuo condominio", to: "/informative" },
  },
  {
    slug: "formazione-amministratori",
    nav: "Formazione per amministratori",
    eyebrow: "Art. 71-bis disp. att. c.c. · D.M. 140/2014",
    title: "Formazione per amministratori",
    image: "/formazione.jpg",
    intro: "Percorsi formativi per amministratori di condominio e per i loro collaboratori, dedicati alla protezione dei dati personali e agli adempimenti di legge nella gestione condominiale.",
    points: [
      ["Privacy nello studio e nel condominio", "Ruoli e responsabilità, informative, gestione dei dati dei condòmini, dei fornitori e dei dipendenti."],
      ["Videosorveglianza e controllo accessi", "Cosa è consentito nelle parti comuni, cartelli, tempi di conservazione delle immagini e diritti degli interessati."],
      ["Sicurezza dei dati", "Misure tecniche e organizzative, gestione delle password, phishing e violazioni dei dati (data breach)."],
      ["Aggiornamenti normativi", "Approfondimenti sulle nuove indicazioni del Garante e sulla giurisprudenza in materia condominiale."],
      ["Incontri in aula e online", "Sessioni pratiche con casi reali, materiale didattico e attestato di partecipazione."],
    ],
    cta: { label: "Richiedi il calendario dei corsi", to: "/contatti?servizio=formazione-amministratori" },
  },
  {
    slug: "analisi-acqua",
    nav: "Analisi acqua nei condomini",
    eyebrow: "D.Lgs. 18/2023 · Acque per consumo umano",
    title: "Analisi acqua nei condomini",
    image: "/acqua.jpg",
    intro: "Controllo della qualità dell'acqua nell'impianto idrico condominiale, dal punto di consegna fino ai rubinetti, per la tutela della salute dei residenti.",
    points: [
      ["Prelievi e analisi di laboratorio", "Campionamenti nei punti significativi dell'impianto e analisi dei parametri chimici e microbiologici."],
      ["Prevenzione della legionella", "Valutazione del rischio negli impianti di acqua calda sanitaria secondo le Linee guida nazionali per la prevenzione della legionellosi."],
      ["Impianto idrico interno", "Supporto all'amministratore negli adempimenti previsti per i sistemi di distribuzione idrica interni dal D.Lgs. 18/2023."],
      ["Referti chiari", "Esiti consegnati all'amministratore con indicazione di eventuali non conformità e interventi consigliati."],
      ["Programmazione dei controlli", "Calendario dei campionamenti periodici in base alle caratteristiche dell'impianto."],
    ],
    cta: { label: "Richiedi un preventivo", to: "/contatti?servizio=analisi-acqua" },
  },
  {
    slug: "assistente-ai-comunicazioni",
    nav: "Assistente AI per le comunicazioni",
    eyebrow: "Intelligenza artificiale · Reg. UE 2024/1689",
    title: "Assistente AI per le comunicazioni",
    image: "/ai.jpg",
    intro: "Un programma di intelligenza artificiale che aiuta l'amministratore a gestire le comunicazioni con i condòmini: avvisi, risposte e segnalazioni più rapidi, sempre con l'ultima parola all'amministratore.",
    points: [
      ["Avvisi e circolari in pochi secondi", "Da una breve indicazione l'assistente prepara convocazioni, avvisi di lavori, interruzioni dei servizi e scadenze, pronti da rivedere e inviare."],
      ["Risposte alle domande frequenti", "Bozze di risposta alle richieste più comuni dei condòmini su rate, regolamento, orari e servizi condominiali."],
      ["Segnalazioni ordinate", "Le segnalazioni dei condòmini vengono riassunte e suddivise per condominio e per urgenza, così nessuna richiesta va persa."],
      ["Riepiloghi chiari", "Sintesi comprensibili di verbali e comunicazioni lunghe, da condividere con i condòmini."],
      ["Nel rispetto della privacy", "Utilizzo conforme al GDPR e al Regolamento europeo sull'intelligenza artificiale: i testi sono sempre verificati e approvati dall'amministratore."],
    ],
    cta: { label: "Richiedi una dimostrazione", to: "/contatti?servizio=assistente-ai-comunicazioni" },
  },
  {
    slug: "consulenza-energetica",
    nav: "Consulenza energetica luce e gas",
    eyebrow: "Energia · Luce e gas condominiali",
    title: "Consulenza energetica luce e gas",
    image: "/energia.jpg",
    intro: "Analisi delle forniture di energia elettrica e gas del condominio per ridurre i costi delle utenze comuni, con un confronto chiaro delle offerte e l'assistenza nel cambio di fornitore.",
    points: [
      ["Analisi delle bollette", "Verifica dei consumi, della potenza impegnata e delle voci di costo delle utenze condominiali di luce e gas."],
      ["Confronto delle offerte", "Comparazione delle offerte del mercato libero più adatte ai consumi del condominio, con prezzi e condizioni spiegati in modo semplice."],
      ["Cambio fornitore senza pensieri", "Gestione delle pratiche di attivazione e di cambio fornitore, senza interruzioni del servizio e senza interventi sugli impianti."],
      ["Supporto all'assemblea", "Prospetti chiari da presentare in assemblea per decidere in modo consapevole sulle forniture."],
      ["Monitoraggio nel tempo", "Controllo periodico delle bollette e delle condizioni contrattuali, con avviso in caso di rinnovi o variazioni di prezzo."],
    ],
    cta: { label: "Richiedi un'analisi delle bollette", to: "/contatti?servizio=consulenza-energetica" },
  },
];
